var DPI_300 = 300;
var PIXELS_PER_METER_300 = Math.round(300 / 0.0254);

export function detectDPIFromFile(arrayBuffer, mimeType) {
  try {
    switch (mimeType) {
      case 'image/png': return detectDPIFromPNG(arrayBuffer);
      case 'image/jpeg': return detectDPIFromJPEG(arrayBuffer);
      case 'image/webp': return detectDPIFromWebP(arrayBuffer);
      default: return null;
    }
  } catch (e) {
    console.warn('DPI detection failed:', e);
    return null;
  }
}

function detectDPIFromPNG(buffer) {
  var view = new DataView(buffer);
  var signature = [137, 80, 78, 71, 13, 10, 26, 10];
  for (var i = 0; i < 8; i++) {
    if (view.getUint8(i) !== signature[i]) return null;
  }
  var offset = 8;
  while (offset < view.byteLength - 12) {
    var length = view.getUint32(offset);
    var type = String.fromCharCode(view.getUint8(offset + 4), view.getUint8(offset + 5), view.getUint8(offset + 6), view.getUint8(offset + 7));
    if (type === 'pHYs') {
      var ppuX = view.getUint32(offset + 8);
      var ppuY = view.getUint32(offset + 12);
      var unit = view.getUint8(offset + 16);
      if (unit === 1) return Math.round(ppuX * 0.0254);
      return null;
    }
    if (type === 'IDAT') break;
    offset += 12 + length;
  }
  return null;
}

function detectDPIFromJPEG(buffer) {
  var view = new DataView(buffer);
  var offset = 2;
  while (offset < view.byteLength - 1) {
    if (view.getUint8(offset) !== 0xFF) { offset++; continue; }
    var marker = view.getUint8(offset + 1);
    if (marker === 0xE0) {
      var length = view.getUint16(offset + 2);
      if (length >= 16) {
        var ident = String.fromCharCode(view.getUint8(offset + 4), view.getUint8(offset + 5), view.getUint8(offset + 6), view.getUint8(offset + 7), view.getUint8(offset + 8));
        if (ident === 'JFIF') {
          var units = view.getUint8(offset + 9);
          var xDensity = view.getUint16(offset + 10);
          var yDensity = view.getUint16(offset + 12);
          if (units === 1) return Math.round((xDensity + yDensity) / 2);
          if (units === 2) return Math.round((xDensity + yDensity) / 2 * 2.54);
        }
      }
      offset += length;
    } else if (marker === 0xE1) {
      offset += view.getUint16(offset + 2);
    } else if (marker === 0xD9 || marker === 0xDA) {
      break;
    } else if ((marker >= 0xD0 && marker <= 0xD7) || marker === 0x01) {
      offset += 2;
    } else {
      offset += 2 + view.getUint16(offset + 2);
    }
  }
  return null;
}

function detectDPIFromWebP() {
  return null;
}

export function writeDPItoPNG(blob, dpi) {
  dpi = dpi || DPI_300;
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onload = function() {
      try {
        var buffer = reader.result;
        var ppu = Math.round(dpi / 0.0254);
        var physData = new ArrayBuffer(9);
        var physView = new DataView(physData);
        physView.setUint32(0, ppu);
        physView.setUint32(4, ppu);
        physView.setUint8(8, 1);
        var physChunk = createChunk('pHYs', new Uint8Array(physData));
        var ihdrEnd = 33;
        var newBuffer = new ArrayBuffer(buffer.byteLength + physChunk.byteLength);
        var newView = new Uint8Array(newBuffer);
        newView.set(new Uint8Array(buffer, 0, ihdrEnd), 0);
        newView.set(new Uint8Array(physChunk), ihdrEnd);
        newView.set(new Uint8Array(buffer, ihdrEnd), ihdrEnd + physChunk.byteLength);
        resolve(new Blob([newBuffer], { type: 'image/png' }));
      } catch (e) { reject(e); }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
}

export function writeDPItoJPEG(blob, dpi) {
  dpi = dpi || DPI_300;
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onload = function() {
      try {
        var buffer = reader.result;
        var view = new DataView(buffer);
        var offset = 2;
        while (offset < view.byteLength - 1) {
          if (view.getUint8(offset) !== 0xFF) { offset++; continue; }
          var marker = view.getUint8(offset + 1);
          if (marker === 0xE0) {
            var ident = String.fromCharCode(view.getUint8(offset + 4), view.getUint8(offset + 5), view.getUint8(offset + 6), view.getUint8(offset + 7), view.getUint8(offset + 8));
            if (ident === 'JFIF') {
              var newView = new DataView(buffer.slice(0));
              newView.setUint16(offset + 10, dpi);
              newView.setUint16(offset + 12, dpi);
              resolve(new Blob([newView], { type: 'image/jpeg' }));
              return;
            }
            break;
          }
          if (marker === 0xD9 || marker === 0xDA) break;
          if ((marker >= 0xD0 && marker <= 0xD7) || marker === 0x01) { offset += 2; continue; }
          offset += 2 + view.getUint16(offset + 2);
        }
        resolve(blob);
      } catch (e) { reject(e); }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
}

export function writeDPItoWebP(blob) {
  return Promise.resolve(blob);
}

function createChunk(type, data) {
  var typeBytes = new TextEncoder().encode(type);
  var length = data.byteLength;
  var chunk = new ArrayBuffer(4 + 4 + length + 4);
  var view = new DataView(chunk);
  view.setUint32(0, length);
  view.setUint8(4, typeBytes[0]);
  view.setUint8(5, typeBytes[1]);
  view.setUint8(6, typeBytes[2]);
  view.setUint8(7, typeBytes[3]);
  new Uint8Array(chunk, 8, length).set(new Uint8Array(data));
  var crcData = new Uint8Array(chunk, 4, 4 + length);
  view.setUint32(8 + length, crc32(crcData));
  return new Uint8Array(chunk);
}

function crc32(data) {
  var crc = 0xFFFFFFFF;
  for (var i = 0; i < data.length; i++) {
    crc ^= data[i];
    for (var j = 0; j < 8; j++) {
      crc = (crc >>> 1) ^ (crc & 1 ? 0xEDB88320 : 0);
    }
  }
  return (crc ^ 0xFFFFFFFF) >>> 0;
}

export { DPI_300, PIXELS_PER_METER_300 };
